import {
  Divider,
  Theme,
  Typography,
  CircularProgress,
  Button,
  Collapse,
  FormControlLabel,
  Switch,
  Alert,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import { getCandidateCredentials } from 'app/services/CredentialingServices';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectMiscellaneousPlacementData,
  selectPlacementHeaderData,
  selectPlacementLandsGtgDetails,
} from '../../../../../../../store/redux-store/placement-details/selectors';
import { placementDetailsAction } from '../../../../../../../store/redux-store/placement-details/slice';
import { candidateDetailActions } from 'app/components/Candidate/CandidateProfile/Profile/CandidateDetails.redux';
import { LicenseDetailedView } from './LicenseSection/LicenseDetailedView';
import { LicenseSelection } from './LicenseSection/LicenseSelection';
import { LandsLicenseFields } from './LandsLicenseFields';
import _ from 'lodash';
import { userRoles } from 'oidc/userRoles';
import { selectUser } from 'oidc/user.selectors';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ICredentials } from 'app/models/Credentialing/Credentials';
import { groupedLicensure } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/CredentialsTab/TableData/Licensure';
import { nestedChildren } from 'app/helpers/arrayHelpers';
import { getStateDesc } from './LandsFormHelper';
import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { FormInputText } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputText';
import { Controller, useFormContext } from 'react-hook-form';
import { getCredentialLookups } from 'app/services/CredentialingServices/CredentialingServices';
import { Authorized } from 'oidc/userHelper';
import { isPositiveNumber } from 'app/helpers/componentHelpers';

const useStyles: any = makeStyles()((theme: Theme) => ({
  root: {
    paddingLeft: '10px',
  },
  sectionTitle: {
    paddingBottom: '6px',
    paddingTop: '6px',
  },
  subTitleStyle: {
    fontWeight: 'bold',
    marginLeft: '-12px',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  btn: {
    fontSize: 12,
    borderRadius: 4,
    color: '#fff',
  },
  primaryBtn: {
    paddingTop: '6px',
    marginBottom: '20px',
    backgroundColor: '#006FB9',
    '&:hover': {
      backgroundColor: '#006FB9',
    },
    '&:focus': {
      backgroundColor: '#006FB9',
    },
  },
  warning: {
    marginBottom: '20px',
  },
  alertContainer: {
    marginLeft: '-13px',
    width: '835px',
  },
  sectionTitleToggle: {
    textAlign: 'end',
  },
  container: {
    padding: '12px 0px 0px 7px',
  },
}));

export const LicenseWrapper = props => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const user = useSelector(selectUser);
  const placementDetails = useSelector(selectPlacementHeaderData);
  const LandsGtgDetails = useSelector(selectPlacementLandsGtgDetails);
  const { licensesList } = useSelector(selectMiscellaneousPlacementData);
  const [progress, setProgress] = useState(false);
  const [enable, setEnable] = useState(true);
  const [change, setChange] = useState(true);
  const [radioChk, setRadioChk] = useState(false);
  const [requirementID, setRequirementID] = useState('');
  const [hasEditAccess, setHasEditAccess] = useState(false);
  const dispatch = useDispatch();
  const [collapse, setCollapse] = useState(true);
  const [selectedRadio, setSelectedRadio] = useState('');
  const [isLicenseNumStateMissing, setIsLicenseNumStateMissing] = useState(false);
  const [isLicenseRequired, setIsLicenseRequired] = useState(LandsGtgDetails?.notRequired);
  const [licenseReasonId, setLicenseReasonId] = useState('');
  const { formState: { errors }, getValues, setValue, control } = useFormContext();
  useEffect(() => {
    if (!LandsGtgDetails?.notRequiredReasonId && props.notRequiredReasonsList) {
      setLicenseReasonId(
        LandsGtgDetails?.notRequiredReasonId
          ? props.notRequiredReasonsList?.find(item => parseInt(item.Id) === LandsGtgDetails?.notRequiredReasonId)
              ?.Description
          : props.notRequiredReasonsList[0]?.Description,
      );
      setValue(
        'piLicenseReason',
        LandsGtgDetails?.notRequiredReasonId
          ? props.notRequiredReasonsList?.find(item => parseInt(item.Id) === LandsGtgDetails?.notRequiredReasonId)
              ?.Description
          : props.notRequiredReasonsList[0]?.Description,
      );
    }

    setValue('piLicenseComment', LandsGtgDetails?.notRequiredReason || '');
    setValue('piLicenseRequired', LandsGtgDetails?.notRequired);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.notRequiredReasonsList]);

  useEffect(() => {
    if (LandsGtgDetails && licensesList && licensesList.length > 0) {
      if (LandsGtgDetails.licenseNumber !== null || LandsGtgDetails.licenseNumber !== '') {
        const res = licensesList?.find(d => d.licenseNumber === LandsGtgDetails.licenseNumber);
        if (res) {
          setSelectedRadio(`License_${res?.requirementID}`);
          setEnable(false);
          setRequirementID(res?.requirementID);
          setChange(false);
          dispatch(placementDetailsAction.setIslicenseSelectRedio(true));
          dispatch(placementDetailsAction.setIslicenseSelect(parseInt(res?.requirementID)));
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [LandsGtgDetails, licensesList]);

  const fetchData = async () => {
    if (placementDetails && isPositiveNumber(placementDetails?.candidate?.id)) {
      setProgress(true);
      dispatch(placementDetailsAction.setIslicenseSelectRedio(false));
      const res = await getCandidateCredentials(placementDetails?.candidate?.id.toString());
      if (res) {
        dispatch(candidateDetailActions.setCredentials(res));
      }
      if (res?.licenses) {
        let classicLicense: any = null;
        if (
          !res?.licenses?.find(
            item =>
              item.licenseNumber === LandsGtgDetails?.licenseNumber &&
              getStateDesc(item?.stateID) === LandsGtgDetails?.licenseStateProvice,
          )
        ) {
          classicLicense = {
            isClassicLicense: true,
            requirementID: LandsGtgDetails?.licenseNumber,
            licenseNumber: LandsGtgDetails?.licenseNumber,
            licenseStateProvince: LandsGtgDetails?.licenseStateProvice,
            expirationDate: LandsGtgDetails?.expirationDate,
          };
        }
        const filterList = filterData(res.licenses);
        dispatch(placementDetailsAction.setLicensesList(filterList));
        //setProgress(false);
        await getCredentialLookups('Licenses')
          .then(response => {
            const updatedLicense = filterList?.map(license => {
              const filteredList = response?.filter(item => item.abbreviation === license.requirementType);
              return {
                ...license,
                lookups: filteredList,
              };
            });
            if (classicLicense && classicLicense.licenseNumber && classicLicense.licenseStateProvince) {
              dispatch(placementDetailsAction.setLicensesList([...updatedLicense, classicLicense]));
            } else {
              dispatch(placementDetailsAction.setLicensesList(updatedLicense));
            }
            setProgress(false);
          })
          .catch(err => console.log(err));
        setProgress(false);
      }
    }
  };

  const sortData = (licenses, index) => {
    const sortListed = _.orderBy(
      licenses,
      (o: any) => {
        return o != null ? o[index] : o;
      },
      ['asc'],
    );

    return sortListed;
  };

  const filterData = licenses => {
    //pull values for TypeIDs 'temporary' and 'permanent'
    const licenseData = licenses?.filter(d => d.typeID === 191 || d.typeID === 192);
    if (licenseData?.length > 0) {
      //Group by versions
      const list = groupedLicensure(licenseData);

      // Get List Same As Credential Tab
      let rootList = nestedChildren(list) as ICredentials[];

      rootList = rootList.map(item => {
        return { ...item, state: getStateDesc(item?.stateID) };
      });

      //Sort by Credential Name
      const sortedList = sortData(rootList, 'credentialName');

      // //Sort by State
      // sortedList = sortData(sortedList, 'state');

      // //Sort by license Number
      // sortedList = sortData(sortedList, 'licenseNumber');

      return sortedList;
    }
    return [];
  };

  useEffect(() => {
    setHasEditAccess(
      Authorized(
        [userRoles.credentialing_Leadership, userRoles.credentialing_TeamMember],
        user.userInfo,
      ),
    );
  }, [user]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placementDetails?.candidate?.id]);

  const handleLicenseSel = requirementID => {
    // dispatch(placementDetailsAction.setIslicenseSelect(licenseNumber));
    setRequirementID(requirementID);
    setEnable(false);
    setRadioChk(true);
    setSelectedRadio(`License_${requirementID}`);
  };

  const toggleSelection = () => {
    setChange(true);
    dispatch(placementDetailsAction.setIslicenseSelectRedio(false));
  };

  const Loading = () => (
    <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
      <CircularProgress />
    </div>
  );

  const SelectionSection = props => {
    return (
      <LayoutGridItem item>
        <LayoutGrid container direction="row" spacing={3} style={{ paddingTop: '10px', marginBottom: '-40px' }}>
          <LayoutGridItem item xs={12}>
            <LicenseSelection
              handleLicenseSel={handleLicenseSel}
              radioChk={radioChk}
              currentRadio={selectedRadio}
              hasEditAccess={hasEditAccess}
              setIsLicenseNumStateMissing={setIsLicenseNumStateMissing}
              isLicenseNumStateMissing={isLicenseNumStateMissing}
            />
          </LayoutGridItem>
        </LayoutGrid>
        <LayoutGrid
          container
          direction="row"
          spacing={3}
          style={{ paddingTop: '35px', marginBottom: change ? '-50px' : '-35px' }}
        >
          <LayoutGridItem item xs={12}>
            <Button
              type="button"
              variant="contained"
              classes={{ root: classes.btn, contained: classes.primaryBtn }}
              disableTouchRipple
              disableFocusRipple
              disabled={enable || !hasEditAccess}
              onClick={() => {
                if (!isLicenseNumStateMissing) {
                  setChange(false);
                  dispatch(placementDetailsAction.setIslicenseSelectRedio(true));
                  dispatch(
                    placementDetailsAction.setIslicenseSelect(
                      requirementID && requirementID !== '' ? parseInt(requirementID) : null,
                    ),
                  );
                  setIsLicenseNumStateMissing(false);
                }
              }}
            >
              {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.islicenseSelect')}
            </Button>
          </LayoutGridItem>
        </LayoutGrid>
      </LayoutGridItem>
    );
  };

  const handleReasonChange = e => {
    setValue('piLicenseReason', e.target.value, { shouldDirty: true });
    setLicenseReasonId(e.target.value);
    setValue('piLicenseComment', '', { shouldDirty: true });
  };

  return (
    <>
      <LayoutGrid container direction="column" className={classes.root}>
        <LayoutGrid
          container
          classes={{ root: classes.root }}
          direction="row"
          data-testid="container"
          justifyContent="flex-start"
          spacing={4}
        >
          <LayoutGridItem item className={classes.sectionTitle} xs={4}>
            <Typography variant="subtitle1" component="div" className={classes.subTitleStyle}>
              {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.lands')}
            </Typography>
          </LayoutGridItem>
          <LayoutGridItem item className={classes.sectionTitleToggle} xs={8}>
            <Controller
              name="piLicenseRequired"
              control={control}
              render={({ field: { onChange, ...rest } }) => (
                <FormControlLabel
                  name="piLicenseRequired"
                  control={
                    <Switch
                      name="piLicenseRequired"
                      checked={!isLicenseRequired}
                      onChange={() => {
                        props.handleToggle(!isLicenseRequired);
                        setValue('piLicenseRequired', !isLicenseRequired);
                        setIsLicenseRequired(!isLicenseRequired);
                      }}
                    />
                  }
                  label=""
                />
              )}
            />
          </LayoutGridItem>
        </LayoutGrid>
        <Divider variant="middle" style={{ marginLeft: '0px' }} />
        <LayoutGridItem item style={{ marginBottom: '-30px' }}>
          <LayoutGrid container>
            <LayoutGridItem item xs={11}>
              <Typography variant="subtitle1" className={classes.heading}>
                {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.LicenseTitle')}
              </Typography>
            </LayoutGridItem>
            <LayoutGridItem item>
              <Typography variant="subtitle1" style={{ cursor: 'pointer' }}>
                {collapse ? (
                  <ExpandLessIcon
                    onClick={() => {
                      setCollapse(!collapse);
                    }}
                  />
                ) : (
                  <ExpandMoreIcon
                    onClick={() => {
                      setCollapse(!collapse);
                    }}
                  />
                )}
              </Typography>
            </LayoutGridItem>
            {/* conditionally render warning  */}
            {isLicenseNumStateMissing && collapse && !isLicenseRequired ? (
              <LayoutGridItem item className={classes.alertContainer}>
                <Alert severity="warning" className={classes.warning}>
                  {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.warningLicenseNumberandStateNameAreMissing')}
                </Alert>
              </LayoutGridItem>
            ) : null}
          </LayoutGrid>
        </LayoutGridItem>
        {progress ? (
          <Loading />
        ) : (
          <Collapse in={collapse}>
            {!isLicenseRequired ? (
              <LayoutGridItem item xs={12} style={{ marginTop: '-6px' }}>
                <>
                  {change ? (
                    licensesList && licensesList?.length > 0 ? (
                      <SelectionSection />
                    ) : (
                      <Alert severity="warning" style={{ width: '70%' }}>
                        {t(
                          'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.noMatchingLicenseFoundForThisPlacement',
                        )}
                      </Alert>
                    )
                  ) : (
                    <>
                      <LicenseDetailedView RequirementID={requirementID} toggleSelection={toggleSelection} />
                      <LandsLicenseFields
                        licenseMetaData={licensesList?.find(x => x.requirementID === requirementID)}
                        handleFieldChanges={props.handleFieldChanges}
                      />
                    </>
                  )}
                </>
              </LayoutGridItem>
            ) : (
              <LayoutGridItem className={classes.container}>
                <LayoutGrid direction="row" justifyContent="space-between">
                  <LayoutGridItem style={{ width: '33.33%' }}>
                    <FormInputDropdown
                      name={'piLicenseReason'}
                      label={t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.reason')}
                      require={false}
                      options={props.notRequiredReasonsList}
                      inputValue={
                        LandsGtgDetails?.notRequiredReasonId
                          ? props.notRequiredReasonsList?.find(
                              item => parseInt(item.Id) === LandsGtgDetails?.notRequiredReasonId,
                            )?.Description
                          : props.notRequiredReasonsList[0]?.Description
                      }
                      handleChange={handleReasonChange}
                      isCheckBox={true}
                    />
                  </LayoutGridItem>
                  <LayoutGridItem style={{ width: '65%' }}>
                    <FormInputText
                      name="piLicenseComment"
                      label={`${t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.enterComment')} `}
                      inputValue={getValues('piLicenseComment') || LandsGtgDetails?.notRequiredReason}
                      isCheckBox={true}
                      require={licenseReasonId === 'Other' ? true : false}
                      message={errors['piLicenseComment']?.message || ''}
                    />
                  </LayoutGridItem>
                </LayoutGrid>
              </LayoutGridItem>
            )}
          </Collapse>
        )}
      </LayoutGrid>
    </>
  );
};
